import { testimonials } from '@/mocks/home';

export default function TestimonialsSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-flex items-center gap-1.5 text-xs font-semibold tracking-wider uppercase text-primary-600 mb-3">
            <i className="ri-double-quotes-l text-sm"></i>
            Testimonials
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-foreground-950 leading-tight">
            Voices of Impact
          </h2>
          <p className="text-foreground-600 text-sm md:text-base mt-3 max-w-xl mx-auto">
            Hear from the youth, parents, and volunteers whose lives have been touched by our programs
          </p>
        </div>

        {/* Testimonials Grid - staggered layout */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {/* Row 1: 3 cards */}
          {testimonials.slice(0, 3).map((t, i) => (
            <div
              key={i}
              className="rounded-2xl p-5 md:p-6 bg-background-100 border border-background-200/60 relative"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 mb-4">
                <i className="ri-double-quotes-l text-lg text-accent-600"></i>
              </div>
              <p className="text-foreground-700 text-sm leading-relaxed mb-5">
                {t.text}
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-background-200/60">
                <div className="w-9 h-9 rounded-full bg-secondary-300 flex items-center justify-center">
                  <span className="text-secondary-700 font-heading font-bold text-sm">
                    {t.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="font-heading font-semibold text-sm text-foreground-900">{t.name}</p>
                  <p className="text-foreground-500 text-xs">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Row 2: Featured wide card + side card */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 mt-5 md:mt-6">
          {/* Wide Featured Card */}
          <div className="md:col-span-2 relative rounded-2xl overflow-hidden aspect-[2/1] md:aspect-auto md:h-64">
            <img
              src="https://readdy.ai/api/search-image?query=Young%20Malaysian%20woman%20working%20confidently%20on%20laptop%20in%20modern%20coworking%20space%2C%20warm%20natural%20lighting%2C%20professional%20yet%20casual%20setting%2C%20determined%20expression%2C%20success%20story%2C%20clean%20bright%20aesthetic&width=1200&height=600&seq=testimonial-featured-2026&orientation=landscape"
              alt="Program graduate success story"
              title="INSAN PERWIRA Graduate Success"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-transparent"></div>
            <div className="absolute bottom-0 left-0 p-6 md:p-7">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-500/90 backdrop-blur-sm mb-3">
                <i className="ri-double-quotes-l text-lg text-background-50"></i>
              </div>
              <p className="text-background-50 text-sm md:text-base leading-relaxed mb-3 max-w-md font-medium">
                &ldquo;{testimonials[3].text}&rdquo;
              </p>
              <p className="text-background-50 font-heading font-semibold text-sm">{testimonials[3].name}</p>
              <p className="text-background-50/70 text-xs">{testimonials[3].role}</p>
            </div>
          </div>

          {/* Side Card */}
          <div className="rounded-2xl p-5 md:p-6 bg-secondary-100 border border-secondary-200/60 flex flex-col justify-between">
            <div>
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-300 mb-4">
                <i className="ri-double-quotes-l text-lg text-secondary-700"></i>
              </div>
              <p className="text-foreground-700 text-sm leading-relaxed mb-5">
                {testimonials[4].text}
              </p>
            </div>
            <div className="flex items-center gap-3 pt-4 border-t border-secondary-200/60">
              <div className="w-9 h-9 rounded-full bg-secondary-400 flex items-center justify-center">
                <span className="text-secondary-800 font-heading font-bold text-sm">
                  {testimonials[4].name.charAt(0)}
                </span>
              </div>
              <div>
                <p className="font-heading font-semibold text-sm text-foreground-900">{testimonials[4].name}</p>
                <p className="text-foreground-500 text-xs">{testimonials[4].role}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}